import { Col, Row } from 'antd';
import { getIpsTeamRoleMembers } from 'api';
import React, { useEffect, useState } from 'react';
import { isIPSDataCreatorOrAdministrator } from 'utils/UserInfo';
import '../projectDetails/projectDetails.css';



function Team({ project,status, history, teamMembers }) {
  

  const onEditTeamHandler = () => {
    history.push({
      pathname: `/${status}/${project.stationName}/${project.bpid}/${project.workOrder}/team`,
    });
  };

  const getMemberNames = (role) => {
    let names = '';
    for (let i = 0; i < role.team.length; ++i) {
      let name = role.team[i].firstName + ' ' + role.team[i].lastName;
      names += name;
      if (i < role.team.length - 1) names += ', ';
    }
    return names;
  };

  return (
    <>
      <div className='border-container padding-container'>
        {isIPSDataCreatorOrAdministrator() && <Row justify='end'>
          <Col>
            <button
              type='button'
              className='w3-button btn-primary '
              onClick={onEditTeamHandler}
            >
              {`${project?.allIPSComplFlag !=='Y'?'Edit':'View'} Team Members`}
            </button>
          </Col>
        </Row>}

        {teamMembers &&
          teamMembers.map((role) => {
            
            return (
              <Row key={role.roleId}>
                <Col span={24}>
                  <Row className='spacing-bottom'>
                    <Col className='key-title ' >
                      {`${role.roleName} :`}
                    </Col>
                    <Col className='value-container' >{getMemberNames(role)}</Col>
                  </Row>
                </Col>
              </Row>
            );
          })}
      </div>
    </>
  );
}
export default Team;
